import { render, staticRenderFns } from "./Integration.vue?vue&type=template&id=27324195&"
import script from "./Integration.vue?vue&type=script&lang=js&"
export * from "./Integration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27324195')) {
      api.createRecord('27324195', component.options)
    } else {
      api.reload('27324195', component.options)
    }
    module.hot.accept("./Integration.vue?vue&type=template&id=27324195&", function () {
      api.rerender('27324195', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/bubble/Integration.vue"
export default component.exports